class Sum {
    constructor() {
        this._init()
    }
    _init() {
        this.el = document.querySelector('[data-sum]')
        if(!this.el) {
            return
        }
        this.el.sum = this
        this.elValues = this.el.querySelectorAll('[data-value]')
        this.elResult = this.el.querySelector('[data-result]')
        this.elActions = document.querySelectorAll('[data-sum-action]')
        this.elActions.forEach(el => el.addEventListener('click', () => this.calculate()))
        this.calculate()
    }
    calculate() {
        let sum = 0
        this.elValues.forEach(el => {
            if(el.dataset.value) {
                sum = Math.max(sum + parseFloat(el.dataset.value), 0)
            }
        })
        this.elResult.setAttribute('data-result', sum)
        if(this.elResult.manager) {
            this.elResult.manager.onValueAction()
        }
        return sum
    }
}

export default Sum